export default __webpack_public_path__ + "static/Card3-8ca38b24e76295e53a9b4207bcd401ef.png";